import { create } from 'zustand';
import { portalAuth, type PortalCustomer } from '../lib/portal-api';

interface PortalAuthState {
  customer: PortalCustomer | null;
  loading: boolean;
  setCustomer: (c: PortalCustomer | null) => void;
  logout: () => Promise<void>;
}

export const usePortalAuth = create<PortalAuthState>((set) => ({
  customer: null,
  loading: true,
  setCustomer: (c) => set({ customer: c, loading: false }),
  logout: async () => {
    try { await portalAuth.logout(); } catch { /* ignorer */ }
    set({ customer: null });
    window.location.href = '/portal/login';
  },
}));
